import { createRelayResource } from '@atlassian/jira-relay-utils/src/services/resources/index.tsx';
import ENTITLEMENTS_CUSTOMER_QUERY, {
	type EntitlementsQuery,
} from '@atlassian/jira-servicedesk-customer-details/src/ui/main/entitlements/__generated__/EntitlementsQuery.graphql';

export const EntitlementsQueryResource = createRelayResource<EntitlementsQuery>({
	type: 'ENTITLEMENTS_CUSTOMER_QUERY',
	getQuery: ({ match }, { tenantContext }) => ({
		parameters: ENTITLEMENTS_CUSTOMER_QUERY,
		variables: {
			accountId: String(match.params.customerId),
			cloudId: tenantContext.cloudId,
		},
		options: { fetchPolicy: 'store-and-network' },
	}),
});
